import * as React from 'react'
import '../../styles/buttons.css'
import '../../styles/global.css'

const GOOGLE_BUTTON_CLASSES = 'google-button'

export type LoginProps = {
  loginHandler: () => void
}

const Login = (props: LoginProps): JSX.Element => {
  return (
    <button
      onClick={props.loginHandler}
      className={GOOGLE_BUTTON_CLASSES}
    ></button>
  )
}

export default Login
